function auxiliar_accountings_Reducer(state = [], action) {
    switch (action.type) {
        case 'ACCOUNTING/AUXILIAR/SET':            
            return action.auxiliar_accountings;
        case 'ACCOUNTING/AUXILIAR/CLEAR':
            return null;
        case 'BOOK/CLEAR':
            return null;
        default:
            return state;
    }
}

export default auxiliar_accountings_Reducer;
